import localforage from 'localforage';

localforage.config({
  name: 'sparrow-web',
  storeName: 'keyValue',
  description: 'Sparrow Web Application Storage',
});

const isStorageAvailable = (): boolean => {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
};

export const Storage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      const value = await localforage.getItem(key);
      return value !== null ? String(value) : null;
    } catch {
      if (isStorageAvailable()) {
        return localStorage.getItem(key);
      }
      return null;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      await localforage.setItem(key, value);
    } catch {
      if (isStorageAvailable()) {
        localStorage.setItem(key, value);
      }
    }
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      await localforage.removeItem(key);
    } catch {
      if (isStorageAvailable()) {
        localStorage.removeItem(key);
      }
    }
  },
  clear: async (): Promise<void> => {
    try {
      await localforage.clear();
    } catch {
      if (isStorageAvailable()) {
        localStorage.clear();
      }
    }
  },
};
